import axios from 'axios';
import { API_ENDPOINT_V1 } from './url';

function sendHeadersAuth() {
  // const token = localStorage.getItem("jwt");
  // const refreshToken = localStorage.getItem("refreshToken");
  return {
    // headers: {
    //   Authorization: `${token}$${refreshToken}`,
    // },
    withCredentials: true,
    'X-Content-Type-Options': 'nosniff',
    'X-Frame-Options': 'deny',
    'Content-Security-Policy': "frame-ancestors 'none'",
    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
    'Cache-Control': 'no-cache, no-store, must-revalidate, max-age=600',
  };
}

const logOut = async () => {
  await axios.post(`${API_ENDPOINT_V1}/auth/logout`);
  window.location.href = '/login';
};

const post = async (url, dataToSend) => {
  try {
    const { data } = await axios.post(url, dataToSend, sendHeadersAuth());
    return data;
  } catch (err) {
    console.error(err);
    if (err.response.status === 401) logOut();
    throw err;
  }
};

const get = async (url) => {
  try {
    const { data } = await axios.get(url, sendHeadersAuth());
    return data;
  } catch (err) {
    console.error(err);
    if (err.response.status === 401) logOut();
    throw err;
  }
};

const deleteRequest = async (url) => {
  try {
    const { data } = await axios.delete(url, sendHeadersAuth());
    return data;
  } catch (err) {
    console.error(err);
    if (err.response.status === 401) logOut();
    throw err;
  }
};

const api = { post, get, delete: deleteRequest };

export default api;
